/**
 * Which workstation hosts a sign-in desktop session (2026-08-18).
 *
 * A sign-in desktop can live on the person's own ACCOUNT workstation
 * (`…/browser-api`) instead of the platform-shared service. Whoever creates
 * such a session registers its base here, and the sign-in window reads it back
 * so every later call for that session goes to the machine that actually
 * hosts it. An unregistered session keeps the shared-base behaviour.
 *
 * Moved here on 2026-09-27 from the old client browse tool's frame-stream
 * module (`globalTools/tools/browserSessionFrames.ts`), which was deleted with
 * that tool (D15). This registry was the only part of it still in use.
 */

const SESSION_BASE_OVERRIDES = new Map<string, string>();

export function registerBrowserSessionBase(sessionId: string, base: string | null): void {
  if (!sessionId) return;
  if (base && base.trim()) SESSION_BASE_OVERRIDES.set(sessionId, base.trim().replace(/\/+$/, ''));
  else SESSION_BASE_OVERRIDES.delete(sessionId);
}

export function getRegisteredBrowserSessionBase(sessionId: string): string | null {
  return SESSION_BASE_OVERRIDES.get(sessionId) ?? null;
}
